import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import CarruselNoticias from "../components/CarruselNoticias";
import ListWithIcons from "../components/ListWithIcons";
import IconsContainer from "../components/IconsContainer";
import { fetchPaginaPrincipal } from "../utils/contentfulRequests";
import QuickCards from "../components/QuickCards";
import InfoCardGroup from "../components/InfoCardGroup";
import ImageCarouselBlock from "../components/ImageCarouselBlock";
import PdfCarousel from "../components/PdfCarousel";
import ImageGallery from "../components/ImageGallery";


const Home = () => {
  const [paginaPrincipal, setPaginaPrincipal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchPaginaPrincipal();
        setPaginaPrincipal(data);
      } catch (error) {
        // no-op
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <Typography>Cargando página...</Typography>;
  }

  if (!paginaPrincipal) {
    return <Typography>No se encontró la página principal.</Typography>;
  }

  return (
    <Box className="Main">
    {/* Si la página incluye componentes del tipo 'cardsInformativas', se renderizarán
      dentro del mapeo más abajo; no renderizamos nada por defecto aquí. */}
      {/* Carrusel de noticias - Elemento fijo */}
      <Box sx={{ marginBottom: "24px" }}>
        <CarruselNoticias height={paginaPrincipal.carruselHeightPx} />
      </Box>

      {/* Renderizar dinámicamente los componentes */}
      {paginaPrincipal.componentes.map((componente, index) => (
        <Box key={index} sx={{ marginTop: "32px" }}>
          {componente.tipo === "bloqueInteractivo" ? (
            <ListWithIcons services={componente} />
          ) : componente.tipo === "IconsContainer" ? (
            <IconsContainer iconos={componente.iconos} />
          ) : componente.tipo === "quickCardsComponent" ? (
            <QuickCards
            cardsData={componente.cards.map((card) => ({
              icon: card.icono, // Asumiendo que es JSX o string de URL
              title: card.titulo,
              description: card.descripcion,
              extraInfo: card.informacionExtra,
              route: card.ruta,
            }))}
          />
          ) : componente.tipo === 'cardsInformativas' ? (
            <InfoCardGroup group={componente.group} slug={componente.slug} allowMultipleOpen={false} />
          ) : componente.tipo === 'imageCarouselBlock' ? (
            <ImageCarouselBlock images={componente.images || []} description={componente.description} background={componente.background} />
          ) : componente.tipo === 'galeriaDeImagenes' ? (
            <ImageGallery images={componente.images || []} />
          ) : componente.tipo === 'pdfCarousel' ? (
            <PdfCarousel
              url={componente.pdf?.fields?.file?.url?.startsWith('//') ? `https:${componente.pdf.fields.file.url}` : componente.pdf?.fields?.file?.url}
              title={componente.titulo}
            />
          ) : null}
        </Box>
      ))}
    </Box>
  );
};

export default Home;
